import { Injectable } from '@angular/core';
import { NextObserver } from 'rxjs';
import { WebSocketSubject } from 'rxjs/webSocket';

@Injectable({
  providedIn: 'root'
})
export class WebsocketConnectionService {
  private connections: Map<string, WebSocketSubject<any>> = new Map<string, WebSocketSubject<any>>();

  constructor() { }

  getConnection<T>(url: string): WebSocketSubject<T> | undefined {
    if (this.connections.has(url)) {
      return this.connections.get(url);
    }
    return undefined;
  }

  createConnection(url: string, openObserver?: NextObserver<Event>, closeObserver?: NextObserver<CloseEvent>) {
    let webSocketSubjectInstance = new WebSocketSubject({
      url,
      openObserver,
      closeObserver
    });

    this.connections.set(url, webSocketSubjectInstance);
    return webSocketSubjectInstance;
  }

  removeConnection(url: string) {
    let webSocketSubjectInstance = this.connections.get(url);
    if (!!webSocketSubjectInstance) {
      webSocketSubjectInstance.unsubscribe()
      this.connections.delete(url)
    }
  }
}
